import React from 'react';

/**
 * Age Verification Modal
 * Shows on first visit for non-authenticated users.
 * Stores verification in sessionStorage to avoid asking again in same session.
 */
export default function AgeVerificationModal({ onVerified }) {
  const handleYes = () => {
    sessionStorage.setItem('age_verified', '1');
    if (onVerified) onVerified();
  };

  const handleNo = () => {
    window.location.href = '/too-young';
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <span style={styles.icon}>🍷</span>
        <h2 style={styles.title}>Welcome to Winesup</h2>
        <p style={styles.text}>
          Winesup is a wine recommendation service.
          To continue, please confirm that you are of legal drinking age in your country.
        </p>
        <p style={styles.question}>Are you of legal drinking age?</p>
        <div style={styles.buttonRow}>
          <button onClick={handleNo} style={styles.btnNo}>
            No, I am not
          </button>
          <button onClick={handleYes} style={styles.btnYes}>
            Yes, I am
          </button>
        </div>
        <p style={styles.disclaimer}>
          By entering, you confirm you are of legal drinking age and agree to our
          responsible drinking guidelines.
        </p>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    zIndex: 2000, padding: '20px',
  },
  modal: {
    background: '#fff', borderRadius: '16px', padding: '48px 40px',
    maxWidth: '440px', width: '100%', textAlign: 'center',
    boxShadow: '0 20px 60px rgba(0,0,0,0.4)',
  },
  icon: { fontSize: '3.5rem' },
  title: { fontSize: '1.7rem', color: '#1a1a1a', margin: '16px 0 8px' },
  text: { color: '#555', lineHeight: '1.6', margin: '0 0 20px' },
  question: { fontWeight: 700, fontSize: '1.1rem', color: '#1a1a1a', margin: '0 0 20px' },
  buttonRow: { display: 'flex', gap: '16px', justifyContent: 'center', marginBottom: '20px' },
  btnNo: {
    padding: '12px 28px', border: '2px solid #ccc', background: '#fff',
    borderRadius: '8px', cursor: 'pointer', fontSize: '1rem', fontWeight: 600,
  },
  btnYes: {
    padding: '12px 28px', background: '#722F37', color: '#fff',
    border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '1rem', fontWeight: 600,
  },
  disclaimer: { color: '#aaa', fontSize: '0.75rem', margin: 0 },
};
